import script from "./label-highlight.vue?vue&type=script&lang=ts&setup=true"
export * from "./label-highlight.vue?vue&type=script&lang=ts&setup=true"

import "./label-highlight.vue?vue&type=style&index=0&id=56a64c5f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a64c5f"]])

export default __exports__